import { Button, Drawer, Flex } from 'antd'
import React, { ReactNode, useCallback, useRef, useState } from 'react'
import { isReactNode } from '@/shared/helpers/react'
import { MobileSkeletonLoader } from '@/components/atoms/MobileSkeletonLoader/MobileSkeletonLoader'
import styles from './DrawerModalAction.module.scss'

type Props = {
  cancelOnClick: () => void;
  cancelTitle: string;
  confirmOnClick: () => void;
  confirmTitle: string;
  description: string | ReactNode;
  title: string;
  confirmLoading?: boolean;
  icon?: ReactNode;
}

export function DrawerModalAction({ description, title, confirmLoading, confirmOnClick, confirmTitle, cancelTitle, cancelOnClick, icon }: Props) {
  const contentRef = useRef<HTMLDivElement | null>(null)
  const [drawerSize, setDrawerSize] = useState<number>(100)
  const [ready, setReady] = useState(false)

  const measure = useCallback(() => {
    const el = contentRef.current
    if (!el) return
    const extra = 24 + 24 + 30
    const max = Math.floor(window.innerHeight * 0.9)
    setDrawerSize(Math.min(max, el.scrollHeight + extra))
    setReady(true)
  }, [])

  return (
    <Drawer
      size={drawerSize}
      onClose={cancelOnClick}
      placement="bottom"
      title={null}
      footer={null}
      open
      afterOpenChange={(isOpen) => {
        if (!isOpen) {
          setDrawerSize(100)
          setReady(false)
          return
        }

        setDrawerSize(100)
        setReady(false)

        requestAnimationFrame(() => {
          requestAnimationFrame(measure)
        })
      }}
    >
      {!ready && <MobileSkeletonLoader height="22px" width="100%" amount={2} />}

      <div ref={contentRef} style={{ visibility: ready ? 'visible' : 'hidden', pointerEvents: ready ? 'auto' : 'none' }}>
        {icon && <Flex justify="center" className={styles.icon}>{icon}</Flex>}

        <h3 className={styles.title}>{title}</h3>

        {isReactNode(description) && typeof description !== 'string' ? (
          <div className={styles.description}>{description}</div>
        ) : (
          <p className={styles.description}>{description}</p>
        )}

        <div className="btnsGroup">
          <Flex vertical gap={10}>
            <Button loading={confirmLoading} className="mobilePrimaryButton" onClick={confirmOnClick} type="primary" block>{confirmTitle}</Button>
            <Button className="mobileSecondaryButton" onClick={cancelOnClick} block>{cancelTitle}</Button>
          </Flex>
        </div>
      </div>
    </Drawer>
  )
}
